import { IntendedUsageType } from 'app/models/enums';

import { User } from './user.model';

export class Contract {
  constructor(
    public id: number,
    public prefix: string,
    public name: string,
    public skipManualValidation: boolean,
    public mstId: string,
    public nationalIdentifier: string,
    public mstVersionNr?: number,
    public description?: string,
    public ncisContractId?: number,
    public contractType?: string,
    public dataproviderType?: string,
    public intendedUsageType?: IntendedUsageType,
    public users?: User[]
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/contract.model.ts